export const buildResiliationList = [
  { id: 'Ne souhaite pas renouveler', value: 'Ne souhaite pas renouveler' },
  { id: 'Vente de véhicule', value: 'Vente de véhicule' },
  { id: 'Véhicule épave suite accident', value: 'Véhicule épave suite accident' },
  { id: 'Véhicule volé non retrouvé', value: 'Véhicule volé non retrouvé' },
  { id: 'Véhicule incendié', value: 'Véhicule incendié' },
  { id: 'Autres', value: 'Autres' },
];
